export function roleLookupModel(result) {
  if (!result?.success || !Array.isArray(result.data)) {
    throw new Error("Role lookup is unavailable.");
  }
  return result.data.map((role) => {
    if (
      !role.uuid ||
      !role.name ||
      !role.permissions ||
      typeof role.permissions !== "object" ||
      Array.isArray(role.permissions)
    ) {
      throw new Error("Invalid role lookup.");
    }
    return {
      value: role.uuid,
      text: role.name,
      permissions: { ...role.permissions },
    };
  });
}
